<cdk-virtual-scroll-viewport
  class="virtual-scroll-viewport"
  [class.empty]="!tableData?.content?.length"
  [style]="getViewportStyle()"
  [itemSize]="50"
  [minBufferPx]="200"
  [maxBufferPx]="400"
  appScrollSync
  [sourceName]=`${resourceParams.path}-body`
  [syncGroup]="resourceParams.path"
>
  <div
    class="body-group-row body-row"
    [style.height]="getBodyGroupRowHeight"
    [style.top.px]="inverseOfTranslation"
  >
    @for (columnParam of columnParamsStateService.getColumnParamsByKey(resourceParams.path); track columnParam.key; let index = $index) {
      @if (isNeedCheckbox(index)) {
        <div class="table-cell body-checkbox sticky"></div>
      }
      @if (isColumnDisplayed(columnParam)) {
        <div
          #bodyCell
          class="table-cell"
          [class]="{
            'separator': columnParam.separated,
            'sticky': columnParam.sticky
          }"
          [attr.data-column]="columnParam.key"
          [style.left.px]="columnParam.leftPositionForStickyColumn"
          [style.width.px]="getWidth(columnParam)"
        ></div>
      }
      @if (columnParam.separated) {
        <div class="separator-column"></div>
      }

      @if (columnParam.hiddenGroupPlaceholder) {
        <div
          app-hidden-group
          class="hidden-group-placeholder"
          [resourceParamsKey]="resourceParams.path"
          [columnParams]="columnParam"
        >
          {{ columnParam.columnProperties.GROUP?.name }}
        </div>
      }
    }
  </div>

  @if (isAddNewRecordStateActive) {
    <div class="body-row">
      <app-table-new-row
        [resourceParamsKey]="resourceParams.path"
        [tableColumnsParams]="columnParamsStateService.getColumnParamsByKey(resourceParams.path) || []"
        [isAnyTableActionAvailable]="isAnyTableActionAvailable && !!tableData?.content?.length"
        (newRecordDataChanged)="handleNewRecordDataChange($event)"
      />
    </div>
  }
  <div
    *cdkVirtualFor="let record of tableData?.content; trackBy: trackByRecordId"
    class="body-row"
    [class]="{
      'selected-row': selectedRowStateService.selectedRowId() === record.id,
      'mistakes-row': record.rowMistakes?.length
    }"
    [style.background-color]="getRowColor(record.rowColor)"
    (click)="handleRowClick(record.id)"
  >
    @for (columnParam of columnParamsStateService.getColumnParamsByKey(resourceParams.path); track $index) {
      @if (isNeedCheckbox($index)) {
        <div class="table-cell body-cell body-checkbox sticky">
          <mat-checkbox
            [checked]="getChecked(record.id)"
            (change)="updateChecked($event.checked, record.id)"
          ></mat-checkbox>
        </div>
      }
      @if (isColumnDisplayed(columnParam)) {
        <div
          #bodyCell
          class="body-cell"
          [class]="{
            'with-background': isColumnWithBackground(columnParam, record),
            'separator': columnParam.separated,
            'sticky': columnParam.sticky
          }"
          [attr.data-column]="columnParam.key"
          [style.left.px]="columnParam.leftPositionForStickyColumn"
          [style.width.px]="getWidth(columnParam)"
        >
          <app-record-table-items-list
            [columnParam]="columnParam"
            [record]="record"
            [resourceParams]="resourceParams"
            [currentTableZoom]="currentTableZoom"
            [isEditModeActive]="isEditModeActive"
            (recordUpdated)="handleRecordUpdate($event)"
            (reloadTableData)="handleReloadTableData()"
          />
          @if (getMistakeMessageForCell(columnParam, record)) {
            <div
              [class]="getIconMistakeMessageClass(columnParam.key)"
              [matTooltip]="getMistakeMessageForCell(columnParam, record)!"
              matTooltipClass="multiline-tooltip"
            ></div>
          }
          @if (isAdvertisementPackage(columnParam.key, record)) {
            <button
              class="advertisement-package-icon"
              [matTooltip]="'Рекламный пакет'"
              [matTooltipShowDelay]="500"
              (click)="handlePackageClick(columnParam.key, record)"
            ></button>
          }
        </div>
      }
      @if (columnParam.separated) {
        <div class="separator-column"></div>
      }

      @if (columnParam.hiddenGroupPlaceholder) {
        <div
          app-hidden-group
          class="hidden-group-placeholder"
          [resourceParamsKey]="resourceParams.path"
          [columnParams]="columnParam"
        ></div>
      }
    }
    @if (isAnyTableActionAvailable) {
      <div class="body-cell table-action">
        <div class="actions-wrapper">
          @for (action of getActions(record); track $index) {
            <div class="action-wrapper">
              <button
                mat-icon-button
                class="action-button"
                [color]="action.color"
                [disabled]="!isEditModeActive"
                (click)="handleActionClick(action.type, record)"
              >
                <mat-icon>{{ action.icon }}</mat-icon>
              </button>
            </div>
          }
        </div>
      </div>
    }
  </div>
</cdk-virtual-scroll-viewport>
